import { FunctionComponent } from 'react';

import { Option } from 'types/options';

import JobNameSuggestion from 'models/JobNameSuggestion';

import { nameSuggestions } from 'requests/jobs';

import AsyncSelect from 'components/layout/forms/AsyncSelect';

import { Props } from './index';
import StyledComponent from './styles';

const PublicLayoutJobsNameSuggestionsSelect: FunctionComponent<Props> = ({ name, label, placeholder, style, value, onChange }) => {
    return (
        <StyledComponent className="public-layout-jobs-name-suggestions-select">
            <AsyncSelect
                name={name}
                label={label}
                placeholder={placeholder}
                style={style}
                value={null}
                onLoad={(query: string) => nameSuggestions({ keyword: query })}
                onMapResponse={(response: JobNameSuggestion[]) => response}
                onMapOption={(element: JobNameSuggestion) => element.getOption()}
                onChange={(option: Option<JobNameSuggestion>) => onChange(option ? option.label : '')}
                selectProps={{
                    inputValue: value,
                    controlShouldRenderValue: false,
                    onInputChange: (newValue: string, actionMeta: { action: string }) => {
                        if (actionMeta.action === 'input-change') onChange(newValue);
                    },
                }}
            />
        </StyledComponent>
    );
};

export default PublicLayoutJobsNameSuggestionsSelect;
